
<template>
  <div>
    <DialogTableExists :saving="loading.saving" :loading="loading.driver" model="o motorista 3º">
      <template slot="header">
        <!-- Veículo com essa placa já cadastrado! -->
        O motorista 3º já está cadastrado no sistema!
      </template>
      <template slot="content">
        <span class="subtitle-1 text-center">
          O motorista 3º<span class="font-weight-bold"> {{ driver.name }}</span> já está cadastrado no sistema!
        </span>
        <span class="subtitle-1 text-center mb-6">
          Você pode incluir outros modúlos na edição dos dados do motorista.
        </span>
      </template>
      <template slot="info">
        <v-col cols="6" class="py-1 ma-0" v-if="driver.name">Nome: <span class="font-weight-medium">{{ driver.name }}</span></v-col>
        <v-col cols="6" class="py-1 ma-0" v-if="driver.cpf">CPF: <span class="font-weight-medium">{{ driver.cpf }}</span></v-col>
        <v-col cols="12" class="py-1 ma-0">
          <div class=" d-flex align-baseline ">
            <v-icon small >mdi-window-shutter-settings</v-icon> 
            <span class="ml-1 subtitle-2 font-weight-black">Cadastrado em:</span>
          </div>
          <v-list>
            <v-list-item v-for="(modality_id, idx) in driver.modality_ids" :key="idx">
              <v-list-item-icon><v-icon>mdi-circle-small</v-icon></v-list-item-icon>
              <v-list-item-title>{{ depots.filter(el=> parseInt(el.id) == parseInt(modality_id))[0].name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
      </template>
      <template slot="actions">
        <v-spacer></v-spacer>
        <f-btn close @click="goBack"></f-btn>
        <f-btn save @click="openClientNewTab" alt_text="Acessar dados do motorista" alt_icon="mdi-open-in-new"></f-btn>
      </template>
    </DialogTableExists>
  </div>
</template>

<script>
import Api from '@/api/index';
import { mapActions } from "vuex"
export default {
  name: 'DriverExist',
  components: {
    SelectDepot: () => import("@/_backoffice/_registrations/components/shared/SelectDepot.vue"),
    DialogTableExists: () => import("@/_backoffice/_registrations/components/shared/DialogTableExists.vue"),
  },
  data() {
    return {
      modality_id: null,
      driver: {},
      loading:{
        driver:false,
      },
      depots: []
    }
  },
  methods: {
    getData() {
      this.getDriver()
      this.getModalities()
    },
    getModalities(){
      Api.Modality.index().then(r => r.data).then((data)=>{
        this.depots = data.map(el => {return {name: el.name, id: el.id}})
      })
    },
    getDriver() {
      this.loading.driver = true
      let id = this.$route.params.id
      Api.Driver.show(id).then(req => req.data).then(data => {
        this.driver = {...data.data.attributes}
      }).finally(()=>{
        this.loading.driver = false
      })
    },
    openClientNewTab(){
      const routeData = this.$router.resolve({name: 'EditDriver', params: {id: this.driver.id}});
      window.open(routeData.href, '_blank');
    },
    goBack(){
      this.$router.push({name:'DriverRegister'})
    },

  },
  mounted() {
    this.getData()
  },
}
</script>